import { render, staticRenderFns } from "./IndexPos.vue?vue&type=template&id=9a1d10ba"
import script from "./IndexPos.vue?vue&type=script&lang=js"
export * from "./IndexPos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports